import {
  HelpCircle,
  ListChecks,
  CheckCircle2,
  ChevronDown,
} from "lucide-react";
import { HighlightComponentProps } from "../highlights";

export const QuizPreview: React.FC<HighlightComponentProps> = ({
  result,
  isExpanded = false,
  onToggleExpand,
}) => {
  const { contents } = result;
  const quiz = contents as any; // QuizSchema
  const questions = quiz?.questions ?? [];

  const PREVIEW_COUNT = 2;
  const visible = isExpanded ? questions : questions.slice(0, PREVIEW_COUNT);

  return (
    <div className="space-y-2">
      {/* Questions */}
      <div className="space-y-2">
        {visible.map((q: any, i: number) => (
          <div
            key={i}
            className="rounded-lg border border-theme bg-theme-1 px-3 py-2.5 hover:border-theme hover:bg-theme-1 transition-colors"
          >
            {/* Question */}
            <div className="flex items-start gap-2.5">
              <div className="mt-0.5 flex h-5 w-5 items-center justify-center rounded-full bg-slate-700 text-[11px] font-bold text-white flex-shrink-0">
                {i + 1}
              </div>

              <div className="flex-1 min-w-0">
                <div className="text-[13px] font-semibold leading-snug text-theme-0 mb-1.5">
                  {q.question}
                </div>

                {/* Options preview - compact 2-column grid */}
                <div className="grid grid-cols-2 gap-x-3 gap-y-0.5 text-[11px] text-theme-1">
                  {q.options.slice(0, 4).map((opt: string, idx: number) => (
                    <div
                      key={idx}
                      className="flex items-start gap-1.5 truncate"
                    >
                      <span className="font-semibold text-theme-1 flex-shrink-0">
                        {String.fromCharCode(65 + idx)}.
                      </span>
                      <span className="truncate">{opt}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Answer hint - more compact */}
            <div className="mt-2 pt-2 border-t border-theme flex items-center gap-1.5 text-[10px] text-theme-1 font-medium">
              <CheckCircle2 className="h-3 w-3 text-emerald-600" />
              Answer & explanation included
            </div>
          </div>
        ))}
      </div>

      {/* Expand affordance */}
      {!isExpanded && questions.length > PREVIEW_COUNT && (
        <button
          onClick={onToggleExpand}
          className="w-full flex items-center justify-center gap-1.5 py-2 text-[11px] font-semibold text-theme-2 hover:text-theme-0 transition-colors rounded-lg hover:bg-theme-1"
        >
          <span>View all {questions.length} questions</span>
          <ChevronDown className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
};
